import { Img } from "@xo-union/tk-component-picture";
import { jsx as _jsx } from "react/jsx-runtime";
var CreativeImage = function CreativeImage(_ref) {
  var id = _ref.id,
    alt = _ref.alt,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_jsx(Img, {
    width: width || 375,
    height: height || 180,
    alt: alt,
    id: id
  });
};
export default CreativeImage;